// @flow
import some from 'lodash/some';
import range from 'lodash/range';
import moment, { isMoment } from 'moment';

export const isSameYear = (a:moment, b:moment) =>
  a.year() === b.year();

export const isSameMonth = (a:moment, b:moment) =>
  isSameYear(a, b) && a.month() === b.month();

export const isSameDay = (a:moment, b:moment) =>
  isSameMonth(a, b) && a.date() === b.date();

export const isInRange = (date:moment, start:moment, end:moment) =>
  (start <= date) && (date <= end);

export const isBeforeToday = (date:moment, granularity:string = 'day') =>
  date.isBefore(moment(), granularity);

export const isOneOfDates = (date:moment, dates:Array<moment>) => {
  if(!dates) return false;
  return some(dates, (compareDate) => isSameDay(date, compareDate));
}

export const daysInMonth = (date:moment) =>
  date.daysInMonth();

export const calendarMonthDates = (monthDate:moment|string) => {
  const momentDate = isMoment(monthDate) ? monthDate.clone() : moment(monthDate);
  const monthFirst = momentDate.date(1);
  const [prevMonth, currentMonth, nextMonth] = [-1, 0, 1]
    .map((addMonths) => monthFirst.clone().add(addMonths, 'month'));

  const prevPadding = range(currentMonth.weekday())
    .reduce((days, i) => ([daysInMonth(prevMonth) - i, ...days]), [])
    .map((date) => moment([prevMonth.year(), prevMonth.month(), date]));
  
  const monthDates = range(1, daysInMonth(currentMonth) + 1)
    .map((date) => moment([currentMonth.year(), currentMonth.month(), date]));

  const lengthModulus = (prevPadding.length + monthDates.length) % 7;
  const nextPadding = range(lengthModulus ? Math.abs(lengthModulus - 7) : 0)
    .map((i) => moment([nextMonth.year(), nextMonth.month(), i + 1]))

  return [].concat(prevPadding, monthDates, nextPadding);
};

export const formatDate = (date:moment|string) => {
  const momentDate:moment = isMoment(date) ? date : moment(date);
  return momentDate.format('DD.MM.YYYY');
};

export const formatDateRange = (dateFrom:moment|string, dateTo:moment|string) => {
  const from_date = isMoment(dateFrom) ? dateFrom : moment(dateFrom);
  const to_date = isMoment(dateTo) ? dateTo : moment(dateTo);
  
  if(isSameDay(from_date, to_date)) {
    return from_date.format('DD.MM.YYYY');
  }
  if(isSameMonth(from_date, to_date)) {
    return `${from_date.format('DD.')}-${to_date.format('DD.MM.YYYY')}`;
  }
  if(isSameYear(from_date, to_date)) {
    return `${from_date.format('DD.MM.')}-${to_date.format('DD.MM.YYYY')}`;
  }
  return `${from_date.format('DD.MM.YYYY')} - ${to_date.format('DD.MM.YYYY')}`;
};

export const formatDateWithPlaceholder = (inputDate:moment|string, placeholderString:string = '...') => {
  const date = !!(inputDate) ? isMoment(inputDate) ? inputDate : moment(inputDate) : undefined;

  if((!date || !date.isValid())) {
    return placeholderString;
  }

  return date.format('DD.MM.YYYY');
};



// WEBPACK FOOTER //
// ./src/utils/date-utils.js